
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/estate-agents/superfeatured-homepage",
      function () {
        return require("private-next-pages/products/estate-agents/superfeatured-homepage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/estate-agents/superfeatured-homepage"])
      });
    }
  